// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"ConfirmationCode_inputContainer__2A4v0","Label":"ConfirmationCode_Label__kMilv"};